/*eslint-disable */
import { Column, Row } from "styles/Global.styled"
import { PostType } from "types/common"
import { Button } from "ui/Button/Button.styled"
import Checkbox from "ui/Checkbox/Checkbox"
import { Input } from "ui/Input/Input.styled"
import { Table } from "ui/Table/Table.styled"
import usePostList from "../hooks/usePostList"
import { useEffect, useState } from "react"
import { toast } from "react-toastify"
import { DELETE } from "modules/Core/api/REST"
import useAuthorizationHeader from "modules/Core/hooks/useAuthorizationHeader"
import moment from "moment"
import { ActionButtons } from "pages/AdminPanelPage/modules/helpers/components/ActionButtons/ActionButtons.styled"
import { Status } from "pages/AdminPanelPage/modules/helpers/components/Status/Status.styled"
import EditButton from "pages/AdminPanelPage/modules/helpers/components/ui/EditButton/EditButton"
import TrashButton from "pages/AdminPanelPage/modules/helpers/components/ui/TrashButton/TrashButton"
import { getPostStatus, getPostStatusText } from "../utils"
import Loading from "modules/components/Loading/Loading"
import usePostContext from "../hooks/usePostContext"

interface PostListProps {
    setCurrentState: React.Dispatch<React.SetStateAction<string>>
    setPostEdit: React.Dispatch<React.SetStateAction<PostType | undefined>>
}

const PostList: React.FC<PostListProps> = ({ setCurrentState, setPostEdit }) => {
    const postCtx = usePostContext()

    const { postList, setPostList, loading, setLoading } = usePostList(
        postCtx.page,
        postCtx.postPerPage,
        postCtx.inputValue
    )
    const [selectedPosts, setSelectedPosts] = useState<number[]>([])

    const headers = useAuthorizationHeader()

    const handleCheckbox = (id: number) => {
        if (selectedPosts.includes(id))
            setSelectedPosts((current) => current.filter((item) => item !== id))
        else setSelectedPosts((current) => [...current, id])
    }

    const handleSelectAll = () => {
        if (selectedPosts.length === postCtx.postPerPage) {
            setSelectedPosts([])
        } else {
            const posts = postList.map((item) => item.id as number)
            setSelectedPosts(posts)
        }
    }

    const handleDelete = async (id: number) => {
        if (
            window.confirm(
                "Вы действительно хотите удалить данные объявления? Удаление отменить невозможно!"
            )
        ) {
            try {
                const { data } = await DELETE("/api/admin/posts/" + id, {}, { headers })

                if (data.ok === 1) {
                    toast.success("Пользователь успешно удален!")
                    setPostList((current) => current.filter((post) => post.id !== id))
                } else {
                    throw new Error(JSON.stringify(data.detail))
                }
            } catch (error) {
                toast.error("Произошла ошибка " + error)
            }
        }
    }

    const handleDeleteSelected = async () => {
        if (
            window.confirm(
                "Вы действительно хотите удалить данных пользователей? Удаление отменить невозможно!"
            )
        ) {
            try {
                const { data } = await DELETE(
                    "/api/admin/posts/",
                    { posts_id: selectedPosts.join(",") },
                    { headers }
                )

                if (data.ok === 1) {
                    toast.success("Пользователи успешно удалены!")
                    setPostList((current) =>
                        current.filter((user) => !selectedPosts.includes(Number(user?.id)))
                    )
                    setSelectedPosts([])
                } else {
                    throw new Error(JSON.stringify(data.detail))
                }
            } catch (error) {
                toast.error("Произошла ошибка " + error)
            }
        }
    }

    const handleEdit = (post: PostType) => {
        setCurrentState("update")
        setPostEdit(post)
    }

    useEffect(() => {
        setLoading(true)
        setSelectedPosts([])
    }, [postCtx.page, postCtx.postPerPage])

    return (
        <>
            <Row justify="space-between">
                <div style={{ width: "100%" }}>
                    <Column gap="1rem">
                        <Row justify="space-between" gap="3rem">
                            <Input
                                type="number"
                                placeholder={`Количество записей на странице: ${postCtx.postPerPage}`}
                                onChange={(e) =>
                                    postCtx.handlePostPerPageChange(+e.currentTarget.value)
                                }
                            />
                            <Input
                                placeholder="Начни вводить текст"
                                value={postCtx.inputValue}
                                onChange={(e) =>
                                    postCtx.handleInputValueChange(e.currentTarget.value)
                                }
                            />
                        </Row>
                    </Column>
                </div>
                <div>
                    {selectedPosts.length > 0 && (
                        <Button btnColor="crimson" onClick={handleDeleteSelected}>
                            Удалить выбранные
                        </Button>
                    )}
                </div>
            </Row>
            {loading ? (
                <Loading />
            ) : (
                <>
                    <Table>
                        <thead>
                            <tr>
                                <td>
                                    <Checkbox
                                        checked={selectedPosts.length === postCtx.postPerPage}
                                        handleChange={handleSelectAll}
                                    />
                                </td>
                                <td>Название объявления</td>
                                <td>Дата публикации</td>
                                <td>Пользователь</td>
                                <td>Статус</td>
                                <td>Действия</td>
                            </tr>
                        </thead>
                        <tbody>
                            {postList?.length > 0 &&
                                postList.map((post: PostType) => {
                                    const { value: statusType, label: statusText } =
                                        getPostStatus(post)

                                    return (
                                        <tr key={post.id}>
                                            <td>
                                                <Checkbox
                                                    checked={selectedPosts.includes(
                                                        post.id as number
                                                    )}
                                                    handleChange={() =>
                                                        handleCheckbox(post.id as number)
                                                    }
                                                />
                                            </td>
                                            <td style={{ maxWidth: "300px" }}>{post.title}</td>
                                            <td>
                                                {moment(post.date).format("DD MMMM YYYY HH:mm:SS")}
                                            </td>
                                            <td>{post?.user?.email}</td>
                                            <td>
                                                <Status type={getPostStatusText(statusType)}>
                                                    {statusText}
                                                </Status>
                                            </td>
                                            <td>
                                                <ActionButtons>
                                                    <EditButton onClick={() => handleEdit(post)} />
                                                    <TrashButton
                                                        onClick={() =>
                                                            handleDelete(post.id as number)
                                                        }
                                                    />
                                                </ActionButtons>
                                            </td>
                                        </tr>
                                    )
                                })}
                        </tbody>
                    </Table>
                    <Row justify="space-between" gap="3rem" style={{ marginTop: "1rem" }}>
                        <Button onClick={postCtx.handleFirstPage} btnColor="lightBlack">
                            Первая страница
                        </Button>
                        <Button onClick={postCtx.handlePrevPage} disabled={postCtx.page === 1}>
                            Предыдущая страница
                        </Button>
                        <Button
                            onClick={() => postCtx.handleNextPage(postList)}
                            disabled={postList.length < postCtx.postPerPage}
                        >
                            Следующая страница
                        </Button>
                    </Row>
                </>
            )}
        </>
    )
}

export default PostList
